//公钥
let PUBLIC_KEY =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDS/P1GjYkaUFkHWPOhIrLFFPuRzq66cFZF24VU6fgkbVeNQ0Oz1EANDt1OH+t59GCXlne8cPa1fxavhBMYGeURcu9RFDkylDtkLmk4ie0NyKztmrLtqjNQk3yxYcOGwjYXMXPgFaneyXp4Hygaos4mps3FNnsYQ4mCwL3ZaZMBSQIDAQAB";
//私钥
let PRIVATE_KEY =
  "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBANL8/UaNiRpQWQdY86EissUU+5HOrrpwVkXbhVTp+CRtV41DQ7PUQA0O3U4f63n0YJeWd7xw9rV/Fq+EExgZ5RFy71EUOTKUO2QuaTiJ7Q3IrO2asu2qM1CTfLFhw4bCNhcxc+AVqd7JengfKBqiziamzcU2exhDiYLAvdlpkwFJAgMBAAECgYACvi88v5JMuUavBcUFD0JrtX4fwyQaYGN+vP/avr/vGUzOFVXH/LZodQ0Dev7AsyCeV+JunLlYWrKczYbCBXQo4914ihynX7T/hjfb5+O8AJerKbmIeVSISwPHBjtf4HdN5nVuhgaQytFFFLVcLhmFVWxOSApRhLREPGxy3S8HUQJBAPG7+wiFnyEuqX8eXL24Dim1YHVRMkkY3uN4HaDJgtZmpBUpsWMetLj3fJNuL35h/ivpl3dHuHkvBLV6f7HpvLMCQQDfcIKj+z4B9h/gwTTP67do+zr/6hXcmCdOpQQgZ/RYObSvHp6il4nMlj5BraH9c4omRGrwTCUxLb2JQSkm3gATAkB3v2hGu3KtzGC4kQDeFpwley0SUKu5XDGluy3qJYjDzsq/lQzDjkV2T1sN6Yprb/2qISggNY4jsfACOnGhX6lTAkEAuecDWuoLslgUN8yoYyHsjLUSZqBdphcWBTH4l/nF662/bkBcnkzUwtpyW/TaJWT/GU2tZ9cCzsMOwmbrlUH57wJBAIASyGsVByIPX1RRetVqjV+J0uz1otmVFRGiAiy4ee2CZHKHmuZxfriEBqRFqvVqtClzjUJG9Y42M1IUlSAQThY=";

// 加密
export const encryptRSA = (data) => {
  //使用公钥加密
  // @ts-ignore
  let encrypt = new JSEncrypt();
  //encrypt.setPrivateKey('-----BEGIN RSA PRIVATE KEY-----'+PRIVATE_KEY+'-----END RSA PRIVATE KEY-----');
  encrypt.setPublicKey(
    "-----BEGIN PUBLIC KEY-----" + PUBLIC_KEY + "-----END PUBLIC KEY-----"
  );
  let encrypted = encrypt.encrypt(data);
  return encodeURIComponent(encrypted);
  // console.log('加密后数据:%o', encrypted);
};

// 解密
export const decryptRSA = (data) => {
  //使用私钥解密
  // @ts-ignore
  let decrypt = new JSEncrypt();
  //decrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----');
  decrypt.setPrivateKey(
    "-----BEGIN RSA PRIVATE KEY-----" +
      PRIVATE_KEY +
      "-----END RSA PRIVATE KEY-----"
  );
  let uncrypted = decrypt.decrypt(data);
  return uncrypted;
  // console.log('解密后数据:%o', uncrypted);
};

import CryptoJS from "crypto-js";

const AES_KEY = "ArWFs6Zd0FlEd&40D2o(Pm+tB#@p+IEu";
export const encryptAES = (data) => {
  try {
    //加密
    const encrypt = CryptoJS.AES.encrypt(
      String(data),
      CryptoJS.enc.Utf8.parse(AES_KEY),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();
    return encodeURIComponent(encrypt);
  } catch (e) {
    return "";
  }
};

export const decryptAES = (data) => {
  //解密
  try {
    return CryptoJS.AES.decrypt(
      decodeURIComponent(data),
      CryptoJS.enc.Utf8.parse(AES_KEY),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString(CryptoJS.enc.Utf8);
  } catch (e) {
    return "";
  }
};
